import { useMemo } from 'react';

import { GroupedSelectOption, SelectOption } from '@scaleaq/scaleui';
import { useTranslation } from 'react-i18next';

import { useInventoryDataCtx } from '@/providers';
import { groupInventoryParentSelectOptionsByType } from '@/utils/inventory';

/** Parent select options from inventory roots; leaf nodes are excluded (non-leaf parents only). */
export const useInventoryParentSelectOptions = (): {
  parentOptions: GroupedSelectOption<SelectOption<string>>[];
} => {
  const { t } = useTranslation();
  const { roots: inventories } = useInventoryDataCtx();
  const parentOptions = useMemo(
    () =>
      groupInventoryParentSelectOptionsByType(inventories, type =>
        t(`deviceTypes.${type}`, {
          defaultValue: type,
        })
      ),
    [inventories, t]
  );
  return { parentOptions };
};
